import React, { useState, useEffect } from 'react'
import styles from './Navbar.module.css'

/*
  Two logos:
  - logoWhite  -> shown at the top over the hero, AND while the mobile menu is open
  - logoColor  -> shown once the bar turns white on scroll-up
*/
import logoWhite from '../../assets/logoWhite.png'
import logoColor from '../../assets/logo.png'

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#work' },
  { label: 'Contact', href: '#contact' },
]

const Navbar = ({ logoTop = logoWhite, logoScrolled = logoColor }) => {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [hidden, setHidden] = useState(false)

  // Scroll: white mode + hide on scroll-down / show on scroll-up
  useEffect(() => {
    let lastY = window.scrollY
    const onScroll = () => {
      const y = window.scrollY
      setScrolled(y > 40)
      if (y > lastY && y > 140) setHidden(true)
      else setHidden(false)
      lastY = y
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [open])

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const headerClass = [
    styles.navbar,
    scrolled && !open ? styles.scrolled : '',   // stay transparent (navy) while menu is open
    hidden && !open ? styles.hidden : '',
  ].join(' ')

  // White logo at the top and while the menu is open; colored logo only on the white bar
  const activeLogo = scrolled && !open ? logoScrolled : logoTop

  return (
    <>
      <header className={headerClass}>
        <nav className={styles.inner}>
          {/* Logo */}
          <a href="#home" className={styles.logo} onClick={() => setOpen(false)}>
            <img src={activeLogo} alt="Collective KatalyX" className={styles.logoImg} />
          </a>

          {/* Desktop links */}
          <ul className={styles.links}>
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <a href={link.href} className={styles.link}>{link.label}</a>
              </li>
            ))}
          </ul>

          {/* CTA */}
          <a href="#contact" className={styles.cta}>Let&apos;s Talk</a>

          {/* Mobile toggle */}
          <button
            className={`${styles.burger} ${open ? styles.burgerOpen : ''}`}
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            <span />
            <span />
            <span />
          </button>
        </nav>
      </header>

      {/* Mobile menu — OUTSIDE the transformed header so it covers the viewport */}
      <div className={`${styles.mobileMenu} ${open ? styles.mobileOpen : ''}`}>
        <ul>
          {NAV_LINKS.map((link) => (
            <li key={link.label}>
              <a href={link.href} className={styles.mobileLink} onClick={() => setOpen(false)}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <a href="#contact" className={styles.mobileCta} onClick={() => setOpen(false)}>
          Let&apos;s Talk
        </a>
      </div>
    </>
  )
}

export default Navbar